var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "informationalModal",
    attrs: {
      "modal-dialog-scrollable": false,
      "modal-dialog-size": _vm.infoType === "Mortgage" ? "xl" : "lg",
    },
    on: { show: _vm.handleShow },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "h5",
              { staticClass: "d-flex flex-row align-items-center" },
              [
                _c("span", { staticClass: "mr-1 text-capitalize" }, [
                  _vm._v(_vm._s(_vm.infoText)),
                ]),
                _vm._v("\n      " + _vm._s(_vm.centerText) + " \n      "),
                _c("switchable-input", {
                  attrs: {
                    "title-text": _vm.days.toString(),
                    loading: _vm.loading,
                    "no-margin": "",
                    "input-style": "max-width: 50px;",
                  },
                  on: { save: _vm.handleNewDays },
                }),
                _vm._v("\n       " + _vm._s(_vm.endText) + "\n      "),
                _vm.infoType !== "Activity" && _vm.isBroker
                  ? [
                      _c("agents-dropdown", {
                        attrs: {
                          "allow-search": "",
                          "preload-agents": false,
                          "selected-agent": _vm.selectedAgentUsername,
                        },
                        on: {
                          "update:selectedAgent": function ($event) {
                            _vm.selectedAgentUsername = $event
                          },
                          "update:selected-agent": function ($event) {
                            _vm.selectedAgentUsername = $event
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.loadingItems
                        ? _c("inline-loader", { staticClass: "ml-2" })
                        : _vm._e(),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "row justify-content-end" }, [
              _c(
                "div",
                { staticClass: "col-auto mr-2 d-flex align-items-center" },
                [
                  _vm.infoType === "Activity"
                    ? _c(
                        "div",
                        { staticClass: "pretty p-switch p-fill mr-2 font-sm" },
                        [
                          _c("input", {
                            attrs: {
                              id: "filter-expired-checkbox",
                              type: "checkbox",
                              name: "filter-expired-checkbox",
                            },
                            domProps: { checked: _vm.expired },
                            on: {
                              change: function ($event) {
                                return _vm.toggleValues("expired")
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "state" }, [
                            _c(
                              "label",
                              {
                                staticClass: "text-gray",
                                attrs: { for: "filter-expired-checkbox" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("boards.filters.pastDue")) + "?"
                                ),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.infoType === "Mortgage"
                    ? _c(
                        "div",
                        { staticClass: "pretty p-switch p-fill mr-2 font-sm" },
                        [
                          _c("input", {
                            attrs: {
                              id: "filter-expired-checkbox",
                              type: "checkbox",
                              name: "filter-expired-checkbox",
                            },
                            domProps: { checked: _vm.completed },
                            on: {
                              change: function ($event) {
                                return _vm.toggleValues("completed")
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "state" }, [
                            _c(
                              "label",
                              {
                                staticClass: "text-gray",
                                attrs: { for: "filter-expired-checkbox" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "dashboard.informationalCards.onlyCompletedApplications"
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.numberOfClients
                    ? _c(
                        "simple-button",
                        {
                          attrs: { type: "primary btn-sm" },
                          on: { click: _vm.downloadCSV },
                        },
                        [
                          _c("icon", {
                            staticClass: "pr-2",
                            attrs: { name: "file-text-o" },
                          }),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("global.actions.downloadAsCSV")) +
                              "\n        "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row pt-3 ml-0 mr-2" },
              [
                _vm.numberOfClients
                  ? _c("informational-table", {
                      attrs: {
                        "table-name": _vm.tableName,
                        "info-type": _vm.infoType,
                      },
                      on: { hide: _vm.hide },
                    })
                  : _c("div", { staticClass: "col-7 offset-3 mb-2" }, [
                      _vm._v(
                        "\n        " + _vm._s(_vm.noResultText) + "\n        "
                      ),
                      _vm.infoType !== "Birthday"
                        ? _c(
                            "a",
                            {
                              staticClass: "primary-color clickable bold",
                              class: { disabled: _vm.isViewOnlyRenewals },
                              attrs: { href: _vm.noResultLocation },
                            },
                            [_vm._v(_vm._s(_vm.$t("global.actions.clickHere")))]
                          )
                        : _vm._e(),
                      _vm._v(
                        "\n        " + _vm._s(_vm.nextStepText) + "\n      "
                      ),
                    ]),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }